<div class="modal-header">
  <h4 class="modal-title ms-3">Claim Cannot be Processed</h4>
  <button type="button" class="btn-close me-2" data-bs-dismiss="modal" aria-label="Close" (click)="this.activeModal.close()"></button>
</div>

<div class="modal-body py-4">
  <div class="container-fluid px-3">
    <div class="alert alert-danger alert-outline-coloured">
      <div class="alert-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      </div>
      <div class="alert-message">
        <strong>Validation failed.</strong>
        <ul class="ps-3 mb-0">
          <li>Some fields may have red outlines indicating missing information. Please review the claim for completeness and accuracy.</li>
          <li>If a repair item has the "Part Type Not Listed" checked, this claim cannot be "Pushed to E2" and must be entered manually in E2.</li>
        </ul>
      </div>
    </div>
  </div>
</div>
